import $api from '../services';

export default {
    login(params) {
        return $api.post('/login', params);
    },
    signUp(params) {
        return $api.post('/register', params);
    },
    logout() {
        return $api.post('/logout');
    },
    passwordSendEmail(data) {
        return $api.post('/forgotten_password', data);
    },
    confirmPassword(data) {
        return $api.post(`/reset_password?token=${data.token}`, data.params);
    },
    confirmEmail(params) {
        return $api.get('/verify_email', params);
    },
    getApiKey() {
        return $api.get('/get_api_key');
    },
};
